import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { i18n } from "@rmp/core/plugins";
import { computed } from "vue";
import { isNil } from "lodash";

interface Props {
	title: string;
	value?: string | number | null;
	inline?: boolean;
	bold?: boolean;
	appendInline?: boolean;
	dense?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDetailsItem',
  props: {
    title: null,
    value: null,
    inline: { type: Boolean, default: false },
    bold: { type: Boolean },
    appendInline: { type: Boolean },
    dense: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { title: string, value?: string | number | null, inline: boolean, bold?: boolean, appendInline?: boolean, dense?: boolean };

const { colors } = useColors();



const value = computed(() => isNil(props.value) ? i18n.tc("details.values.missingData") : props.value);


return { __sfc: true,colors, props, value, RmpText }
}

})